import { useEffect, useState } from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "context/GameAuthContext";

/**
 * Hook to handle passwordless login
 */
export function usePasswordlessLogin(roomTemplateId?: string) {
	const location = useLocation();
	const { passwordlessLogin } = useAuthContext();

	const [isLoggingIn, setIsLoggingIn] = useState(false);

	const passwordlessToken = queryString.parse(location.search)?.token as string;
	// Check if login method is passwordless
	const isPasswordlessLogin = queryString.parse(location.search)?.p === "1" && !!passwordlessToken && roomTemplateId;

	useEffect(() => {
		if (!isPasswordlessLogin) {
			return;
		}
		async function autoLogin() {
			setIsLoggingIn(true);
			try {
				await passwordlessLogin(roomTemplateId!, passwordlessToken);
			} catch {
				// Redirect user to regular login page if login fails
				const newUrl = queryString.exclude(window.location.href, ["token", "p"]);
				window.location.href = newUrl;
			} finally {
				setIsLoggingIn(false);
			}
		}

		autoLogin();
	}, [isPasswordlessLogin, passwordlessLogin, passwordlessToken, roomTemplateId]);
	return { isLoggingIn };
}
